module.exports = __webpack_public_path__ + "img/icon-arrow-white.f51513b5.svg";